(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/banner-game-promotions/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/widgets/banner-game-promotions/assets/javascripts/init.js');
'use strict';

svs.widget = svs.widget || {};
svs.widget.banner_game_promotions_grid = svs.widget.banner_game_promotions || {};
svs.widget.banner_game_promotions_grid = svs.banner_groups.banner_game_promotions;

 })(window);